/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import WeatherController from '../../domain/dashboard/components/weather/WeatherController';
import ReporterController from '../../domain/dashboard/components/reporter/ReporterController';
import { Grid, Box, Typography } from '@mui/material';
import UpcomingEventsController from '../../domain/dashboard/components/UpcomingEvents/UpcomingEventsController';
import PendingRequestController from '../../domain/dashboard/components/pendingRequests/PendingRequestController';
import TImelineController from '../../domain/dashboard/components/Timeline/TImelineController';
import DashboardCalendarController from '../../domain/dashboard/components/DashboardCalendar/DashboardCalendarController';
import { fonts, themes } from '../../common/themes/themes';
import './Dashboard.css';
import InnerbarDashboardController from '../../common/components/InnerBarDashboard/InnerbarDashboardController';
import AnimatedPage from '../../common/AnimatedPage/AnimatedPage';
import '../i18n';
import Compdirection from '../../common/themes/CompDirection';
import { useAppSelector } from '../../infra/hooks';

interface PropValue {
  trans: any;
  i18n: any;
}

const DashboardPresenter = ({ i18n, trans }: PropValue) => {
  const isHRView = useAppSelector((state) => state.isHRViewSlice.HRView);

  const showSideBar = useAppSelector(
    (state) => state.userAccessSlice.InnerbarDashboardAccess,
  );
  const configMenuList = useAppSelector(
    (state: any) => state.sideMenuSlice?.conigMenu,
  );
  const dynamicMenuNames = configMenuList.map((menu: any) => menu.name);
  return (
    <Grid
      container
      style={{
        marginTop: !isHRView ? '4em' : '',
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          display: 'flex',
          flexWrap: 'wrap',
        }}
      >
        <Grid
          container
          style={{
            marginRight: i18n.language == 'ar' ? '7em' : '',
          }}
        >
          {showSideBar && (
            <Grid item xs={2} sm={2} md={2} lg={2}>
              <InnerbarDashboardController />
            </Grid>
          )}

          <Grid item xs={10} sm={10} md={10} lg={10}>
            <Box
              style={{
                backgroundColor: '#F5F5FA',
                paddingLeft: '1.75em',
              }}
            >
              <Grid
                container
                spacing={2}
                style={{
                  zIndex: '-1',
                }}
                className="container"
              >
                <AnimatedPage>
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    sx={{
                      display: 'flex',
                      padding: '20px',
                      flexWrap: 'wrap',
                    }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        sx={{
                          width: '100%',
                          marginTop: '1.75em',
                        }}
                      >
                        <Box
                          style={{
                            width: 'auto',
                            height: 'auto',
                            background: '#FFFFFF 0% 0% no-repeat padding-box',
                            borderRadius: '10px',
                            opacity: '1',
                          }}
                        >
                          <Grid
                            item
                            xs={12}
                            sx={{
                              display: 'flex',
                              flexDirection: 'row',
                              paddingTop: '1em',
                              paddingBottom: '1em',
                              paddingLeft: '1em',
                              paddingRight: '1em',
                            }}
                          >
                            <Grid item xs={9}>
                              <Compdirection>
                                <Typography
                                  style={{
                                    fontFamily: fonts.fontFamily,
                                    fontSize: fonts.header,
                                    color: themes.blackDefault,
                                    fontWeight: 'bold',
                                  }}
                                >
                                  {trans('Dashboard')}
                                </Typography>
                              </Compdirection>
                            </Grid>
                          </Grid>
                        </Box>
                      </Grid>
                    </Grid>

                    <div className="margin-x-auto card-container">
                      <div className="card">
                        <WeatherController />
                      </div>
                      <div className="card">
                        <ReporterController />
                      </div>
                      {
                        !dynamicMenuNames.includes("Dashboard-What's New") && (
                          <div className="card">
                            <UpcomingEventsController />
                          </div>
                        )
                      }
                      <div className="card">
                        <DashboardCalendarController />
                      </div>
                      <div className="card">
                        <TImelineController />
                      </div>
                      <div className="card">
                        <PendingRequestController />
                      </div>{' '}
                    </div>
                  </Grid>
                </AnimatedPage>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DashboardPresenter;
